import { useFieldArray, useFormContext } from 'react-hook-form';
import { Table } from 'components/shared/Table';
import { SimpleTextCell } from 'components/Table/Cells/SimpleTextCell';
import {
  IntegrationSettingsEntry,
  IntegrationSettingsForm,
  IntegrationSettingsAccountLevelForm,
} from 'modules/integrationSettings/types';
import { IntegrationSettingsTypedInput } from '../typedInput';

interface UserTabProps {
  integrationSettings: IntegrationSettingsEntry[];
  tableData: IntegrationSettingsAccountLevelForm[];
}

export const IntegrationSettingsTable = ({ integrationSettings, tableData }: UserTabProps) => {
  const { control } = useFormContext<IntegrationSettingsForm>();

  const columns = [
    {
      Header: 'Name',
      accessor: 'accountName',
      Cell: ({ original }: any) => <SimpleTextCell value={original.accountName} />,
    },
  ]
    .concat(
      integrationSettings.map(setting => {
        return {
          accessor: setting.name,
          Header: setting.displayName,
          Cell: ({ original, index }: any) => (
            <IntegrationSettingsTypedInput
              key={original.accountId}
              dataKey={original.accountId}
              integrationSettingsEntry={setting}
            />
          ),
          filterable: false,
          sortable: false,
        };
      })
    )
    .map(header => ({
      ...header,
      resizable: false,
      headerClassName: 'customHeader',
    }));

  return <Table<IntegrationSettingsAccountLevelForm> tableData={tableData} columns={columns} />;
};
